import * as React from 'react';
import {CssBaseline} from '@mui/material';
import PrimaryAppBar from './components/AppBar';
import Footer from './components/Footer';

export default function Main({props}) {

  const [address, setAddress] = React.useState(null)

  React.useEffect(()=>{
    location()
  },[])

  const location=()=>{
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(success, error, {maximumAge:60000, timeout:5000, enableHighAccuracy:true});
    } else {
      // Geolocation is not supported by this browser
      console.log("Geolocation is not supported by this browser.");
    }
  }
      
   function success(position) {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
  
    console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);  

    const queryParams = {
      latlng: `${latitude}, ${longitude}`,
      key:"AIzaSyA12JeQMiuUtxPYUtZLH144k-0Yyo9m23I"
    }

    getAddress(queryParams).then((response)=>{
      if(response.status == 200){
        console.log(response.data[6])
        setAddress(response.data[6])
      }else{
        console.log(response.message)
      }
    })
  }
  
  function error(err) {
    console.warn(`ERROR(${err.code}): ${err.message}`);
  }

  const getAddress = async(queryParams)=>{
    try{
      const params = new URLSearchParams(queryParams).toString()
      
      console.log(`https://maps.googleapis.com/maps/api/geocode/json?`+params)
      const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?`+params, {
              method: "GET"
          }
      )
      const json = await response.json()
      return {data: json.results, status: response.status, message: json.message}
    }catch(error){
        return {data: null, status: 400, message: error.message}
    }
  }

  return (
    <>
      <CssBaseline />
      {/* Header */}
      <PrimaryAppBar location={location} address={address}></PrimaryAppBar>
        {/*End Header */}
      {props}
      {/* Footer */}
      <Footer></Footer>
      {/* End footer */}
    </>
  );
}